module.exports = __webpack_public_path__ + "img/27.0e15adb4.png";